<template>
    <navigation />

    <promo-header>
        <h1>
          {{ $t("home.heading") }}
        </h1>
    </promo-header>

    <section class="section section-blue">

        <div class="container">

            <h2 class="mb-4">
                {{ $t("endorsements.title") }}
            </h2>

            <blockquote class="mt-5 mb-2">
                <strong>
                    <em>
                        "{{ $t("endorsements.quote_1") }}"
                    </em>
                </strong>
            </blockquote>

            <p align="right">
                {{ $t("endorsements.quote_1_name") }}
                {{ $t("endorsements.quote_1_role") }}
            </p>

            <hr class="my-5" />

            <blockquote class="mt-5 mb-2">
                <em>
                    "{{ $t("endorsements.quote_2") }}"
                </em>
            </blockquote>

            <p align="right">
                {{ $t("endorsements.quote_2_name") }}
            </p>

            <hr class="my-5" />

            <blockquote class="mt-5 mb-2">
                <em>
                    "{{ $t("endorsements.quote_3") }}"
                </em>
            </blockquote>

            <p align="right">
                {{ $t("endorsements.quote_3_name") }}
            </p>

            <hr class="my-5" />

            <blockquote class="mt-5 mb-2">
                <em>
                    "{{ $t("endorsements.quote_4") }}"
                </em>
            </blockquote>

            <p align="right">
                {{ $t("endorsements.quote_4_name") }}
            </p>

            <hr class="my-5" />

            <blockquote class="mt-5 mb-2">
                <em>
                    "{{ $t("endorsements.quote_5") }}"
                </em>
            </blockquote>

            <p align="right">
                {{ $t("endorsements.quote_5_name") }}
            </p>

            <hr class="my-5" />

            <blockquote class="mt-5 mb-2">
                <em>
                    "{{ $t("endorsements.quote_6") }}"
                </em>
            </blockquote>

            <p align="right">
                {{ $t("endorsements.quote_6_name") }}
            </p>

            <hr class="my-5" />

        </div>

    </section>

    <site-footer />
</template>

<script>
import PromoHeader from "../partials/PromoHeader.vue";
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";

export default {
    name: "Endorsements",

    components: {
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("endorsements.title")}`,
        };
    },
};
</script>
